import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
  html: true, // Enable HTML tags
  breaks: true, // Convert line breaks to <br> tags
});

export default md;
